import SlimSelect from 'slim-select';

/**
 * Initialize Slim Select on filters
 */
export default function initSelect() {
    const selects = document.querySelectorAll('select');

    if (selects.length === 0) return;

    selects.forEach(select => {
        new SlimSelect({
            select: select,
            settings: {
                showSearch: false
            },
            events: {
                afterOpen: () => {
                    const content = document.querySelector('.ss-content.ss-open');
                    if (content) {
                        content.setAttribute('data-lenis-prevent', '');
                    }
                }
            }
        });
    });
}
